
import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AppBreadcrumbService } from './../app.breadcrumb.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ConfirmationService, } from 'primeng/api';
import { CoreService } from '../../core/_services/core.services';
import { ValidatorUtils } from '../../core/_util/validator-util';
import { AlertasService } from '../../core/_services/alerta.service';
import { StepsModule } from 'primeng/steps';
import { MenuItem } from 'primeng/api';
import { listaSiNo } from '../../core/_util/listas-utils';
import { CALENDARIO_ESPANOL } from 'src/app/core/_util/fechas';

interface tipoDocumento {
  name: string,
  code: string
}

interface generos {
  name: string,
  code: string
}

@Component({
  selector: 'app-registro',
  templateUrl: './registro.component.html',
  styleUrls: ['./registro.component.scss']
})
export class RegistroComponent extends ValidatorUtils implements OnInit {

  formBuilder: FormBuilder;
  formulariouno: FormGroup;
  formulariodos: FormGroup;
  formulariotres: FormGroup;

  cargandoPagina: boolean = false;
  submitted: Boolean = false;
  nuevaContrasena: any;
  mensaje: any;
  item: any;
  nombres: string;
  confirmacion: any;
  fecha: Boolean = false;
  claveMax: Boolean = false;
  claveMin: Boolean = false;
  claveMayusc: Boolean = false;
  claveMinusc: Boolean = false;
  claveNum: Boolean = false;
  claveCaracter: Boolean = false;
  claveIgual: Boolean = false;
  claveNombre: Boolean = false;
  claveCedula: Boolean = false;
  correoIgual: Boolean = false;
  datos: any;
  expreg = new RegExp("[A-Z]");
  expregmin = new RegExp("[a-z]");
  expregnum = new RegExp("[0-9]");
  expregcar = new RegExp("[)&.\-/:}=+*${;'#%(]");
  nuevaClave: any;
  items: MenuItem[];
  paso: number = 0;
  listaTiposGeneros: any[];
  tipoDocumento: any[];
  nuevaCedula: any;
  nuevoNombre: any;
  nuevoPapellido: any;
  nuevoSapellido: any;
  nuevoEmail: string;
  nuevocEmail: string;
  listaCiudadResidencia: any[] = [];
  ciudad: string;

  es = CALENDARIO_ESPANOL;


  constructor(
    private breadcrumbService: AppBreadcrumbService,
    public coreService: CoreService,
    public spinner: NgxSpinnerService,
    public confirmationService: ConfirmationService,
    public msj: AlertasService,
  ) {
    super();
    this.formBuilder = new FormBuilder();
    this.formulariouno = this.formBuilder.group({
      nuevaCedula: ['', [Validators.required]],
      tipoDocumento: ['', [Validators.required]],
      nuevoNombre: ['', [Validators.required]],
      nuevoPapellido: ['', [Validators.required]],
      nuevoSapellido: ['', []],
    });

    this.formulariodos = this.formBuilder.group({
      ciudad: ['', [Validators.required]],
      fecha: ['', [Validators.required]],
      genero: ['', [Validators.required]],
      telefono: ['', [Validators.required]],

    });


    this.formulariotres = this.formBuilder.group({
      nuevoEmail: ['', [Validators.required, Validators.email]],
      nuevocEmail: ['', [Validators.required]],
      nuevaContrasena: ['', [Validators.required]],
      confirmacion: ['', [Validators.required]],
      acepto_politicas: ['', [Validators.required]],


    });


    this.tipoDocumento = [
      { name: 'Cédula de Ciudadanía', code: '1' },
      { name: 'Cédula de Extranjeria', code: '2' },
      { name: 'Tarjeta de Identidad', code: '3' },
      { name: 'Pasaporte', code: '4' }

    ];


    this.listaTiposGeneros = [
      { name: 'MASCULINO', code: 1 },
      { name: 'FEMENINO', code: 2 },
      { name: 'INDIFERENTE', code: 3 }


    ];
  }

  ngOnInit(): void {
    this.breadcrumbService.setItems([
      { label: 'Registrar' }
    ]);

    this.items = [
      {
        label: 'Registro',
        command: (event: any) => {
          this.paso = 0;
        }
      },
      {
        label: 'Información Básica',
        disabled: (this.paso < 2) ? true : false,
        command: (event: any) => {
          this.paso = 1;
        }
      },
      {
        label: 'Crear Cuenta',
        disabled: (this.paso < 3) ? true : false,
        command: (event: any) => {
          this.paso = 2;
        }
      }
    ];

  }

  verificate_nacimiento() {
    var fecha_doc = Date.parse(this.formulariodos.value.fecha);
    var fecha_hoy = Date.parse(Date());
    var fecha_80 = (fecha_hoy - 2522880000000);
    var fecha_15 = (fecha_hoy - 473040000000);
    if (fecha_doc <= fecha_80) {

      this.fecha = false;
      return "La fechade nacimiento no puede ser mayor a 80 años";



    } else if (fecha_doc >= fecha_15 && fecha_doc <= fecha_hoy) {

      this.fecha = false;
      return "La fecha de nacimiento no puede ser menor a 15 años";

    } else if (fecha_doc >= fecha_hoy) {

      this.fecha = false;
      return "La fecha de nacimiento no puede ser mayor al dia de hoy";

    } else {

      this.fecha = true;

    }

  }
  anterior() {
    if (this.paso > 0) {
      this.paso = this.paso - 1;
    }

  }

  siguiente() {
    if (this.paso < 2) {
      if ((this.paso == 0 && this.formulariouno.valid) || (this.paso == 1 && this.formulariodos.valid) || (this.paso == 2 && this.formulariotres.valid)) {
        this.paso = this.paso + 1;
      } else {
        if (this.paso == 0) {
          this.formulariouno.markAllAsTouched();
        }
        if (this.paso == 1) {
          this.formulariodos.markAllAsTouched();
        }
      }
    }

  }


  validaIgual(e) {
    if (this.formulariotres.value.nuevaContrasena !== undefined && this.formulariotres.value.confirmacion !== undefined) {

      if (this.formulariotres.value.nuevaContrasena === this.formulariotres.value.confirmacion) {
        this.claveIgual = true;
        return "green";
      } else {
        this.claveIgual = false;
        return "red";
      }

    }

  }

  validaIgualcorreo(e) {
    if (this.formulariotres.value.nuevoEmail !== undefined && this.formulariotres.value.nuevocEmail !== undefined) {

      if (this.formulariotres.value.nuevoEmail === this.formulariotres.value.nuevocEmail) {
        this.correoIgual = true;
        return "green";
      } else {
        this.correoIgual = false;
        return "red";
      }

    }

  }

  validaClavemin(e) {
    if (this.formulariotres.value.nuevaContrasena !== undefined) {
      if (this.formulariotres.value.nuevaContrasena.length < 8) {
        this.claveMin = false;
        return "red";

      } else {

        this.claveMin = true;
        return "green";
      }
    }
  }

  validaClavemax(e) {
    if (this.formulariotres.value.nuevaContrasena !== undefined) {
      if (this.formulariotres.value.nuevaContrasena.length > 40) {
        this.claveMax = false;
        return "red";

      } else {
        this.claveMax = true;
        return "green";


      }
    }
  }

  validaMayusc(e) {
    if (this.formulariotres.value.nuevaContrasena !== undefined) {
      if (!this.expreg.test(this.formulariotres.value.nuevaContrasena)) {
        this.claveMayusc = false;
        return "red";
      } else {
        this.claveMayusc = true;
        return "green";
      }
    }
  }

  validaMinusc(e) {
    if (this.formulariotres.value.nuevaContrasena !== undefined) {
      if (!this.expregmin.test(this.formulariotres.value.nuevaContrasena)) {
        this.claveMinusc = false;
        return "red";
      } else {
        this.claveMinusc = true;
        return "green";
      }
    }
  }

  validaNumero(e) {
    if (this.formulariotres.value.nuevaContrasena !== undefined) {
      if (!this.expregnum.test(this.formulariotres.value.nuevaContrasena)) {
        this.claveNum = false;
        return "red";
      } else {
        this.claveNum = true;
        return "green";
      }
    }
  }

  validaCaracter(e) {
    if (this.formulariotres.value.nuevaContrasena !== undefined) {
      if (!this.expregcar.test(this.formulariotres.value.nuevaContrasena)) {
        this.claveCaracter = false;
        return "red";
      } else {
        this.claveCaracter = true;
        return "green";
      }
    }
  }


  validaCedula(e) {
    if (this.formulariotres.value.nuevaContrasena !== undefined) {

      if (this.formulariotres.value.nuevaContrasena.includes(this.formulariouno.value.nuevaCedula)) {
        this.claveCedula = false;
        return "red";
      } else {
        this.claveCedula = true;
        return "green";
      }
    }
  }

  validaNombre(e) {
    if (this.formulariotres.value.nuevaContrasena !== undefined && this.formulariotres.value.nuevaContrasena !== '') {
      const nombre = this.formulariouno.value.nuevoNombre.split(' ');
      for (let i = 0; i < nombre.length; i++) {
        if (this.formulariotres.value.nuevaContrasena.includes(nombre[i].toLowerCase())) {
          this.claveNombre = false;
          return "red";

        }
      }
      if (this.formulariotres.value.nuevaContrasena.includes(this.formulariouno.value.nuevoPapellido.toLowerCase()) || this.formulariotres.value.nuevaContrasena.includes(this.formulariouno.value.nuevoSapellido.toLowerCase()) || this.formulariotres.value.nuevaContrasena.includes(this.formulariotres.value.nuevoEmail.toLowerCase())) {
        this.claveNombre = false;
        return "red";
      } else {
        this.claveNombre = true;
        return "green";
      }
    }
  }


  getListaCiudadResidencia(e) {
    let params = { texto: e.query }
    if (e.query.length > 2) {
      this.coreService.getWithParams('/lugares', params).subscribe(
        (res: any[]) => {
          this.listaCiudadResidencia = res;
        },
        (err: any) => {
          console.log(err);
        }
      )
    }
  }

  /*getlistatipogenero() {
    this.coreService.get('/listas/generos').subscribe(
      (res: any[]) => {
        this.listaTiposGeneros = res;
      },
      (err: any) => {
        console.log(err);
      }
    )
 
  }*/

  registrar() {

    if (this.formulariotres.value.acepto_politicas) {

      if (this.fecha && this.claveMax && this.claveMin && this.claveCaracter && this.claveCedula && this.claveIgual && this.claveMayusc && this.claveMinusc && this.claveNombre && this.claveNombre && this.claveNum && this.correoIgual) {
        this.confirmationService.confirm({
          message: '¿Deseas registrarte?',

          accept: () => {
            this.submitted = true;
            this.guardarDatos();
          }
        });


      } else {
        this.msj.info("La contraseña no cumple con las condiciones");
      }

    } else {
      this.msj.info("Debes aceptar las políticas de privacidad");
    }
  }
  guardarDatos() {

    let data = {
      tipo_id: this.formulariouno.value.tipoDocumento.code,
      cedula: this.formulariouno.value.nuevaCedula,
      nombres: this.formulariouno.value.nuevoNombre,
      papellido: this.formulariouno.value.nuevoPapellido,
      sapellido: this.formulariouno.value.nuevoSapellido,
      fecha_nacimiento: this.formulariodos.value.fecha,
      genero: this.formulariodos.value.genero.code,
      ciudad_residencia: this.formulariodos.value.ciudad.cod_ciudad,
      departamento_residencia: this.formulariodos.value.ciudad.cod_departamento,
      pais_residencia: this.formulariodos.value.ciudad.cod_pais,
      telefono_movil: this.formulariodos.value.telefono,
      email: this.formulariotres.value.nuevoEmail,
      password: this.formulariotres.value.nuevaContrasena,
      acepto_politicas_privacidad: 1

    }

    console.log(data);
    this.coreService.post('/registrar-usuario', data).subscribe(
      (res: any[]) => {

        this.msj.info(res)


      },
      (err: any) => {

        this.msj.info(err);
      }
    )
  }




}
